const skipPaths = [
  // Root path
  "/",
  
  // PageExten module paths
  "/cua-hang.html", 
  "/tra-don-hang", 
  "/hoi-dap", 
  "/hoi-dap/tim-kiem", 
  "/vouchers",
  "/flash-deal",  
  "/supportdetail", 
  
  // Customer module paths
  "/customer",
  "/customer/my-account",
  "/customer/my-profile",
  "/customer/addresses-details",
  "/customer/my-coupon",
  "/customer/membership-card",
  "/customer/my-wishlist",
  "/customer/my-recently-viewed",
  "/customer/order-history",
  
  // Checkout module paths
  "/checkout",
  "/orderdetailpayonline",
  "/odershopeepayment",
  
  // Others from existing skipPaths
  "/membership"
];

export default skipPaths;
